import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: window.sessionStorage.getItem('value') || '',
  type: window.sessionStorage.getItem('type') || 1
};

export const slice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    changeSearch: (state, action) => {
      const { payload = {} } = action;
      const keys = Reflect.ownKeys(payload);
      keys.forEach(item => {
        state[item] = payload[item];
      });
    }
  },
});

export const { changeSearch } = slice.actions;



export default slice.reducer;